import { Sprite } from "pixi.js";

import { AbstractSymbol } from "../../../../abstracts/elements/AbstractSymbol";
import { log } from "../../../../abstracts/utils/AbstractConsole";
import { symbolsArray } from "../../../config/ApocalypseConfig";
import { ApocalypseSymbolNames } from "../../../types/ApocalypseEnums";
import { ApocalypseBlankSymbol } from "./ApocalypseBlankSymbol";
import { ApocalypseScatterSymbol } from "./ApocalypseScatterSymbol";
import { ApocalypseSymbol } from "./ApocalypseSymbol";
import { ApocalypseWildSymbol } from "./ApocalypseWildSymbol";
import { ApocalypseXNudgeSymbol } from "./ApocalypseXNudgeSymbol";

export class ApocalypseSymbolPool {
    private symbolName: string;
    private pool: AbstractSymbol[] = [];

    constructor(symbolName: string) {
        this.symbolName = symbolName;
    }

    public getSymbol(): AbstractSymbol {
        let symbol: AbstractSymbol | undefined = this.pool.shift();

        if (symbol === undefined) {
            switch (this.symbolName) {
                case ApocalypseSymbolNames.WILD:
                    symbol = new ApocalypseWildSymbol();
                    break;

                case ApocalypseSymbolNames.BLANK:
                case ApocalypseSymbolNames.DUMP:
                    symbol = new ApocalypseBlankSymbol();
                    break;

                case ApocalypseSymbolNames.XNUDGE:
                    symbol = new ApocalypseXNudgeSymbol();
                    break;

                case ApocalypseSymbolNames.SCATTER:
                    symbol = new ApocalypseScatterSymbol();
                    break;

                default:
                    symbol = new ApocalypseSymbol(this.symbolName);
            }
        }

        return symbol;
    }

    public returnSymbol(symbol: AbstractSymbol) {
        symbol.reset();
        symbol.parent?.removeChild(symbol);

        this.pool.push(symbol);
    }
}

const poolsMap: { [k: string]: ApocalypseSymbolPool } = {};

[...symbolsArray].forEach((symbolName: string) => {
    poolsMap[symbolName] = new ApocalypseSymbolPool(symbolName);
});

export const getSymbolFromPool = (name: string): AbstractSymbol => {
    if (!poolsMap[name]) {
        log(`Texture for symbol ${name} does not exist!`);
    }

    const symbol = poolsMap[name].getSymbol()!;

    const textureSprite: Sprite = symbol.getMainTextureSprite();

    if (textureSprite) {
        textureSprite.tint = 0xffffff;
    }

    return symbol;
};
export const returnSymbolToPool = (symbol: AbstractSymbol) =>
    poolsMap[symbol.name].returnSymbol(symbol);
